import {
  list_feiraoNormal,
  list_feiraoLarge,
  list_feiraoxLarge,
  list_feiraoMobile,
} from 'assets/temporary/feirao/banners'

import {
  list_mobile,
  list_normal,
  list_large,
  list_xlarge,
} from 'assets/temporary/blackout/banners'

import {
  blackoutDay_listing_mobile,
  blackoutDay_listing_normal,
  blackoutDay_listing_large,
  blackoutDay_listing_xLarge,
} from 'assets/temporary/blackout/BlackoutDay/banners'

import { SALE_CAMPAIGNS, isAnActiveCampaign } from 'utils/checkCampaign'

const banners = []

if (isAnActiveCampaign(SALE_CAMPAIGNS.feirao)) {
  const feiraoBanner = {
    sourceMobile: list_feiraoMobile,
    sourceNormal: list_feiraoNormal,
    sourceLarge: list_feiraoLarge,
    sourceXLarge: list_feiraoxLarge,
    link: `https://resale.com.br/busca?campanha-exclusiva=feirao`,
    campaignName: 'Feirão',
  }

  banners.unshift(feiraoBanner)
}

if (isAnActiveCampaign(SALE_CAMPAIGNS.blackout)) {
  const blackoutBanner = {
    sourceMobile: list_mobile,
    sourceNormal: list_normal,
    sourceLarge: list_large,
    sourceXLarge: list_xlarge,
    link: `busca?campanha-exclusiva=blackout`,
    campaignName: 'Blackout',
  }

  banners.unshift(blackoutBanner)
}

if (isAnActiveCampaign(SALE_CAMPAIGNS.blackoutDay)) {
  const blackoutDayBanner = {
    sourceMobile: blackoutDay_listing_mobile,
    sourceNormal: blackoutDay_listing_normal,
    sourceLarge: blackoutDay_listing_large,
    sourceXLarge: blackoutDay_listing_xLarge,
    link: `busca?campanha-exclusiva=blackoutday`,
    campaignName: 'BlackoutDay',
  }

  banners.unshift(blackoutDayBanner)
}

const numberOfBanners = banners.length

const getRandomBannerIndex = () => Math.floor(Math.random() * numberOfBanners)

const getSpecificBannerIndex = termo =>
  banners.findIndex(banner =>
    banner.campaignName.toLowerCase().includes(termo && termo.toLowerCase())
  )

const shouldDisplay = banners.length > 0

export { getRandomBannerIndex, getSpecificBannerIndex, banners, shouldDisplay }
